module.exports = __webpack_public_path__ + "static/media/SpecialThanks_Title.aebe622c.png";